import React, { useState, useEffect } from 'react';
import { Modal, Button, Spinner, Table } from 'react-bootstrap';
import RequestServies from "../../../services/RequestServies";
import Swal from "sweetalert2";

const ItemViewModal = ({ show, handleClose, item }) => {
    const [itemData, setItemData] = useState([]);
    const [loading, setLoading] = useState(false);

    const fetchItemData = async () => {
        try {
            setLoading(true);
            const response = await RequestServies.getUsedItemByMiv(item?._id);
            if (response?.status === "success") {
                setItemData(response?.data);
            }
        } catch (err) {
            console.log(err.response.data.message);
        } finally {
            setLoading(false);
        }
    };


    useEffect(() => {
        if (show && item) {
            fetchItemData();
        }
    }, [show, item]);

    const handlePrint = () => {
        const formatDate = (dateString) => {
            if (!dateString) return "";
            const date = new Date(dateString);
            return date.toLocaleDateString("en-GB", {
                day: "2-digit",
                month: "short",
                year: "numeric",
            }).replace(",", "");
        };

        const printWindow = window.open('', '_blank');
        let htmlContentForMIV = `
    <html lang="en">
<head>
    <meta charset="utf-8"/>
    <meta content="width=device-width, initial-scale=1.0" name="viewport"/>
    <title>Material Issues Voucher</title>
    <script src="https://cdn.tailwindcss.com"></script>
</head>
<body style="background-color: #f3f4f6; padding: 1rem; font-family: Arial, sans-serif;">
    <div style="max-width: 64rem; margin: 0 auto; background-color: white; padding: 1.5rem; border: 1px solid #d1d5db;">
        <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 1rem;">
            <div>
                <h1 style="font-size: 1.25rem; font-weight: bold;">Indigo Infraprojects Pvt. Ltd.</h1>
                <p>3rd Floor, Plot No. - 12/B, Pocket 3, Sector – 17, Dwarka</p>
                <p>New Delhi – 110 075</p>
                <p>Ph : +91-11-4572 0741, 4445 8664</p>
            </div>
            <div>
                <img src="https://indigoinfra.in/img/product/product-1739471679615.jpeg" alt="Company Logo" style="height: 3rem;"/>
            </div>
        </div>
<div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 1rem;">
  <div style="flex: 1;"></div>
  <div style="flex: 1; text-align: center; font-size: 1rem; font-weight: bold;">DIGITAL COPY</div>
  <div style="flex: 1; text-align: right; font-size: 1.1rem; font-weight: bold;">MATERIAL ISSUES VOUCHER</div>
</div>
        <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 1rem; margin-bottom: 1rem;">
            <div>
                <p>MIV No. : <strong>${item?.mivNo}</strong></p>
                <p>Machine : <strong></strong></p>
                 <p>MIV Date : <strong>${formatDate(item?.createdAt)}</strong></p>
            <p>Request By : <strong>${item?.user?.name}</strong></p>
            <p>MIV Status : 
  <strong>
    ${item?.status === 'submit'
                ? 'Pending with Project Manager'
                : item?.status === 'close'
                    ? 'Closed'
                    : item?.status ?? 'N/A'}
  </strong>
</p>

       
            </div>
            <div>
                <p>Project Code : <strong>${item?.store?.storeCode}</strong></p>
                <p>Project Name : <strong style="text-transform: capitalize;">${item?.store?.name}</strong></p>
                <p>Location : <strong style="text-transform: capitalize;">${item?.store?.location}</strong></p>
                <p>Date : <strong>${formatDate(item?.createdAt)}</strong></p>
            </div>
        </div>
        <div style="margin-bottom: 1rem;">
            </div>
        <table style="width: 100%; border-collapse: collapse; border: 1px solid #d1d5db; margin-bottom: 1rem;">
            <thead>
                <tr>
                    <th style="border: 1px solid #d1d5db; padding: 0.5rem;">S.No.</th>
                    <th style="border: 1px solid #d1d5db; padding: 0.5rem;">Part No</th>
                    <th style="border: 1px solid #d1d5db; padding: 0.5rem;">Description</th>
                    <th style="border: 1px solid #d1d5db; padding: 0.5rem;">Approved Qty</th>
                    <th style="border: 1px solid #d1d5db; padding: 0.5rem;">Used Qty.</th>
                    <th style="border: 1px solid #d1d5db; padding: 0.5rem;">Remarks</th>
                </tr>
            </thead>
            <tbody>
                <!-- Repeat this row as needed -->
                 ${itemData.map((item, index) => `
                  <tr>
                    <td style="border: 1px solid #cbd5e0; padding: 8px; height: 32px; text-align: center;">${index + 1}</td>
                     <td style="border: 1px solid #cbd5e0; padding: 8px; text-align: center;">${item?.inventory?.masterItem?.partNo}</td>
                    <td style="border: 1px solid #cbd5e0; padding: 8px; text-align: center;">${item?.inventory?.masterItem?.description}</td>
                    <td style="border: 1px solid #cbd5e0; padding: 8px; text-align: center;">${item?.approveQty}</td>
                    <td style="border: 1px solid #cbd5e0; padding: 8px; text-align: center;">${item?.usedQty}</td>
                    <td style="border: 1px solid #cbd5e0; padding: 8px;text-align: center;">${item?.status === 'approved' ? 'Closed' : item?.status ?? 'N/A'}</td>
                </tr>
                `).join('')}
                
            </tbody>
        </table>
        <div style="display: flex; justify-content: space-between; margin-top: 1rem;">
            <div style="text-align: center;">
                <p style="border-top: 1px solid black; display: inline-block; width: 8rem;">Approved By</p>
            </div>
            <div style="text-align: center;">
                <p style="border-top: 1px solid black; display: inline-block; width: 8rem;">Stores Officer</p>
            </div>
            <div style="text-align: center;">
                <p style="border-top: 1px solid black; display: inline-block; width: 8rem;">Received By</p>
            </div>
        </div>
    </div>
</body>
</html>
    `

        printWindow.document.write(htmlContentForMIV);
        printWindow.document.close();
        printWindow.print();
    };


    return (
        <Modal className="fade" show={show} onHide={handleClose} size="lg">
            <Modal.Header>
                <Modal.Title><i className="fas fa-eye"></i> Item Details</Modal.Title>
                <Button variant="" className="btn-close" onClick={handleClose}></Button>
            </Modal.Header>

            <Modal.Body>
                {loading ? (
                    <div className="text-center py-5">
                        <Spinner animation="border" variant="primary" />
                        <div className="mt-2">Loading item data...</div>
                    </div>
                ) : itemData.length === 0 ? (
                    <div className="text-center py-4">No item data found.</div>
                ) : (
                    <Table striped bordered hover responsive size="sm">
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>Part No</th>
                                <th>Description</th>
                                <th>Used Required</th>
                                <th>Status</th>
                            </tr>
                        </thead>
                        <tbody>
                            {itemData.map((itm, index) => (
                                <tr key={index}>
                                    <td>{index + 1}</td>
                                    <td>{itm?.inventory?.masterItem?.partNo || 'N/A'}</td>
                                    <td>{itm?.inventory?.masterItem?.description || 'N/A'}</td>
                                    <td>{itm?.usedQty ?? 'N/A'}</td>
                                    <td>{itm?.status === 'approved' ? 'Closed' : itm?.status ?? 'N/A'}</td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                )}
            </Modal.Body>

            <Modal.Footer>
                {/*
                <Button variant="success" onClick={handlePrint}>
                    Print
                </Button>
*/}
                <Button variant="danger" onClick={handleClose}>
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default React.memo(ItemViewModal);
